import { Col, Descriptions, Form, FormProps, Input, Modal, ModalProps, Row, Select, Space, Typography, useSelect } from '@pankod/refine-antd'
import { useTable } from '@pankod/refine-core'
import { IQuestionType, IReportTheme, ISubject, ISubTheme, ITheme, ITopic } from 'interfaces'
import React, { useEffect, useState } from 'react'
import { availableLanguages } from 'utility/languages'
import { useTableBloomsLevel, useTableCompetencies, useTableDifficultyLevel, useTableStrands } from 'utility/masterData'
type CreatePaperTemplateProps = {
  modalProps: ModalProps
  formProps: FormProps
  record: any
  testTrackQueryResult: any
  sectionId: any
  resetData: any
  sectionTotal: any
  // refreshDataSection:any
}
export const CreateSubSection: React.FC<CreatePaperTemplateProps> = ({
  modalProps,
  formProps,
  record,
  testTrackQueryResult,
  sectionId,
  resetData,
  sectionTotal,
  // refreshDataSection,
}) => {
  const [marks, setMarks] = useState<number>(0)
  const [questionCount, setQuestionCount] = useState<number>(0)
  const [disabled, setDisabled] = useState<boolean>(false)
  const [questionLimitExceed, setQuestionLimitExceed] = useState<boolean>(false)
  const [marksLimitExceed, setMarksLimitExceed] = useState<boolean>(false)
  const [selectedTopic, setSelectedTopic] = useState<any>('')
  const [baseLanguage, setBaseLanguage] = useState()
  const difficultyResult = useTableDifficultyLevel(modalProps?.visible)
  const bloomsResult = useTableBloomsLevel(modalProps?.visible)
  const competencyResult = useTableCompetencies(modalProps?.visible)
  const strandResult = useTableStrands(modalProps?.visible)

  const { setFilters: setSubjectFilter, tableQueryResult: subjectkQueryResult } = useTable<ISubject>({
    resource: 'subjects',
    metaData: {
      fields: ['id', 'name'],
    },
    initialPageSize: 1000,
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const {
    tableQueryResult: topicResult,
    filters: topicFilters,
    setFilters: setTopicFilters,
    sorter,
  } = useTable<ITopic>({
    resource: 'topics',
    initialPageSize: 1000,
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: { fields: ['id', 'name', 'sub_theme_id'] },
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const {
    filters: themeFilters,
    setFilters: setThemeFilters,
    tableQueryResult: themeResult,
  } = useTable<ITheme>({
    resource: 'themes',
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'subject_id'] },
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const {
    filters: reportThemeFilters,
    setFilters: setReportThemeFilters,
    tableQueryResult: reportThemeResult,
  } = useTable<IReportTheme>({
    resource: 'report_themes',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'subject_id'] },
    queryOptions: { enabled: !!modalProps?.visible },
    // initialFilter: [{ field: 'subject_id', operator: 'eq', value: formProps?.initialValues?.subject_id }],
  })

  const {
    filters: subThemeFilters,
    setFilters: setSubThemeFilters,
    tableQueryResult: subThemeResult,
  } = useTable<ISubTheme>({
    resource: 'sub_themes',
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'theme_id'] },
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const { selectProps: questionTypeSelectProps } = useSelect<IQuestionType>({
    resource: 'question_types',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    queryOptions: { enabled: !!modalProps?.visible },
  })
  const { selectProps: reportThemeProps, queryResult: reportThemeQueryResult } = useSelect<IReportTheme>({
    resource: 'report_themes',
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 100000,
    metaData: {
      fields: ['id', 'name', 'topic_ids','theme_ids'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      {
        field: 'theme_ids',
        operator: 'nnull',
        value: true,
      },
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],

    queryOptions: { enabled: !!modalProps?.visible },
  })

  useEffect(() => {
    if (record?.test_track_id !== '' && record?.test_track_id !== null && record?.test_track_id !== undefined) {
      setSubjectFilter([
        {
          field: 'id',
          operator: 'in',
          value: testTrackQueryResult?.data?.data[0]?.subject_ids ?? [],
        },
      ])
      //   setShowSubjectData(true)
    } else {
      //   setShowSubjectData(false)
    }
  }, [testTrackQueryResult?.data?.data])
  const handleSubjectChange = (value: { value: any }) => {
    reportThemeFilters.pop()
    formProps?.form?.setFieldsValue({
      report_theme_id: null,
      sub_theme_id: null,
      topic_id: null,
      theme_id: null,
      questionResult: null,
    })
    setThemeFilters([
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ])
    setReportThemeFilters([
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const handleReportThemeChange = (value: { value: any }) => {
    themeFilters.pop()
    formProps?.form?.setFieldsValue({
      theme_id: null,
      sub_theme_id: null,
      topic_id: null,
    })
    setThemeFilters([
      {
        field: 'report_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const handleThemeChange = (value: { value: any }) => {
    subThemeFilters.pop()
    formProps?.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
      report_theme_id: null,
    })
    setSubThemeFilters([
      {
        field: 'theme_id',
        operator: 'eq',
        value: value,
      },
    ])
    setSelectedTopic(value)
  }
  const handleSubThemeChange = (value: { value: any }) => {
    topicFilters.pop()
    formProps?.form?.setFieldsValue({
      topic_id: null,
    })
    setTopicFilters([
      {
        field: 'sub_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const onFinish = async (values: any) => {
    return (
      formProps.onFinish &&
      formProps.onFinish({
        ...values,
        section_id: sectionId,
        paper_template_id: record?.id,
      })
    )
  }

  useEffect(() => {
    let disableSave = false
    let marksExceed = false
    let quesExceed = false
    let marksLimit: number = 0
    let questionsLimit: number = 0

    record?.product.sections.forEach((section: any) => {
      if (section.section_id === sectionId) {
        // alert(1)
        marksLimit = +section.marks
        questionsLimit = +section.no_of_questions
      }
    })
    if (sectionTotal.length > 0) {
      let foundSection = sectionTotal.findIndex((elem: any) => elem?.section_id === sectionId)
      if (foundSection === -1) {
        quesExceed = questionCount > questionsLimit ? true : false
        marksExceed = marks * questionCount > marksLimit ? true : false
        disableSave = marksExceed || quesExceed
      } else {
        if (sectionTotal[foundSection]?.total_mark !== undefined && sectionTotal[foundSection]?.question_count !== undefined) {
          marksExceed = sectionTotal[foundSection]?.total_mark + marks * questionCount > marksLimit ? true : false
          quesExceed = sectionTotal[foundSection]?.question_count + questionCount > questionsLimit ? true : false

          disableSave = marksExceed || quesExceed
        }
      }
    } else {
      quesExceed = questionCount > questionsLimit ? true : false
      marksExceed = marks * questionCount > marksLimit ? true : false
      disableSave = marksExceed || quesExceed
    }

    setDisabled(disableSave)
    setMarksLimitExceed(marksExceed)
    setQuestionLimitExceed(quesExceed)
  }, [questionCount, marks])

  return (
    <Modal
      {...modalProps}
      title="Create Sub Section"
      okButtonProps={{ ...modalProps.okButtonProps, disabled: disabled }}
      afterClose={() => {
        setMarks(0)
        setQuestionCount(0)
        setDisabled(false)
        setQuestionLimitExceed(false)
        setMarksLimitExceed(false)
        formProps?.form?.resetFields()
      }}
    >
      <Form
        {...formProps}
        layout="vertical"
        onFinish={values =>
          onFinish(values).then(() => {
            // refreshDataSection()
            resetData()

            formProps?.form?.resetFields()
          })
        }
      >
        <Space style={{ display: 'flex', marginBottom: 8 }} align="baseline">
          <Row gutter={[8, 0]}>
            <Col xs={24} lg={3}>
              <Form.Item name={'name'} rules={[{ required: true, message: 'Missing Section' }]}>
                <Input placeholder="Name" type="small" />
              </Form.Item>
            </Col>

            <Col xs={24} lg={3}>
              <Form.Item name={'subject_id'} rules={[{ required: true, message: 'Please select a subject' }]}>
                <Select
                  placeholder="Subject"
                  onChange={handleSubjectChange}
                  showSearch
                  filterOption={(input, option) => {
                    if (option && option.children) {
                      return option.children.toString().toLowerCase().includes(input.toLowerCase())
                    }
                    return false
                  }}
                  optionFilterProp="children"
                >
                  {subjectkQueryResult?.data?.data?.map((item: any) => (
                    <option value={item?.id}>{item?.name}</option>
                  ))}
                  {/* {subjectList.length > 0 && subjectList.map((item: any) => <option value={item?.id}>{item?.name}</option>)} */}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} lg={3}>
              <Form.Item name={'theme_id'} rules={[{ required: true, message: 'Please select a theme' }]}>
                <Select
                  placeholder="Theme"
                  onChange={handleThemeChange}
                  showSearch
                  filterOption={(input, option) => {
                    if (option && option.children) {
                      return option.children.toString().toLowerCase().includes(input.toLowerCase())
                    }
                    return false
                  }}
                  optionFilterProp="children"
                >
                  {themeResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>{' '}
            </Col>
            {/* _____________REPORT THEME */}
            <Col xs={24} lg={3}>
              <Form.Item name={'report_theme_id'} rules={[{ required: true, message: 'Please select a Report theme' }]}>
                <Select
                  placeholder="Report Theme"
                  showSearch
                  filterOption={(input, option) => {
                    if (option && option.children) {
                      return option.children.toString().toLowerCase().includes(input.toLowerCase())
                    }
                    return false
                  }}
                  optionFilterProp="children"
                >
                  {reportThemeQueryResult?.data?.data?.map(item => {
                    console.log(reportThemeQueryResult?.data?.data,'selected topic')
                    if (item.theme_ids && item.theme_ids.includes(selectedTopic)) {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      )
                    }
                  })}
                </Select>
              </Form.Item>
            </Col>
            {/* _____________REPORT THEME */}
            <Col xs={24} lg={3}>
              <Form.Item name={'sub_theme_id'} rules={[{ required: true, message: 'Please select a sub theme' }]}>
                <Select
                  placeholder="Sub Theme"
                  onChange={handleSubThemeChange}
                  showSearch
                  filterOption={(input, option) => {
                    if (option && option.children) {
                      return option.children.toString().toLowerCase().includes(input.toLowerCase())
                    }
                    return false
                  }}
                  optionFilterProp="children"
                >
                  {subThemeResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} lg={3}>
              <Form.Item name={'topic_id'} 
              // rules={[{ required: true, message: 'Please select a topic' }]}
              >
                <Select
                  placeholder="Topic"
                  // onChange={value => {
                  //   formProps.form?.setFieldsValue({
                  //     report_theme_id: null,
                  //   })
                  //   setSelectedTopic(value)
                  // }}
                  showSearch
                  filterOption={(input, option) => {
                    if (option && option.children) {
                      return option.children.toString().toLowerCase().includes(input.toLowerCase())
                    }
                    return false
                  }}
                  optionFilterProp="children"
                >
                  {topicResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/* <Col xs={24} lg={3}>
              <Form.Item
                name={'report_theme_id'}
                 rules={[{ required: true,message:'Please select a Report theme' }]}
              >
                <Select placeholder="Report Theme" 
                 showSearch
                 filterOption={(input, option) => {
                   if (option && option.children) {
                     return option.children
                       .toString()
                       .toLowerCase()
                       .includes(input.toLowerCase());
                   }
                   return false;
                 }}
                 optionFilterProp="children"
                >
                  {reportThemeQueryResult?.data?.data?.map(item => {
                    if (item.topic_ids && item.topic_ids.includes(selectedTopic)) {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      )
                    }
                  })}
                </Select>
              </Form.Item>
            </Col> */}
            {/* -------- */}
            {/* blooms */}
            <Col xs={24} lg={3}>
              <Form.Item name={'blooms_level_id'} rules={[{ required: true, message: 'Please select one bloom level' }]}>
                <Select placeholder="Blooms Level">
                  {bloomsResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/* difficulty */}
            <Col xs={24} lg={3}>
              <Form.Item name={'difficult_level_id'} rules={[{ required: true, message: 'Please select one difficulty level' }]}>
                <Select placeholder="Difficulty Level">
                  {difficultyResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/* Competencies */}
            <Col xs={24} lg={3}>
              <Form.Item name={'competency_id'}>
                <Select placeholder="Competency">
                  {competencyResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/* strands */}
            <Col xs={24} lg={3}>
              <Form.Item name={'strand_id'}>
                <Select placeholder="Standard">
                  {strandResult?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/* ------- */}
            <Col xs={24} lg={2}>
              <Form.Item name={'question_type_id'} rules={[{ required: true }]}>
                <Select {...questionTypeSelectProps} placeholder="Question Type" />
              </Form.Item>
            </Col>
            <Col xs={24} lg={2}>
              <Form.Item name={'no_of_questions'} rules={[{ required: true, message: 'Missing No of Questions' }]}>
                <Input placeholder="No of Questions" type="small" onChange={e => setQuestionCount(parseInt(e.target.value))} />
              </Form.Item>
              {questionLimitExceed && <Typography.Text type="danger">Questions Exceeded !!</Typography.Text>}
            </Col>
            <Col xs={24} lg={2}>
              <Form.Item name={'mark_per_question'} rules={[{ required: true, message: 'Missing Marks' }]}>
                <Input
                  placeholder="Mark per Question"
                  type="small"
                  onChange={e => {
                    setMarks(parseInt(e.target.value))
                  }}
                />
              </Form.Item>
              {marksLimitExceed && <Typography.Text type="danger">Marks Exceeded !!</Typography.Text>}
            </Col>

                       <Col xs={24} lg={2}>
                          <Form.Item name={'base_lang'}>
                            <Select
                              placeholder="Base Language"
                              onChange={value => {
                                setBaseLanguage(value)
                                formProps?.form?.setFieldsValue({
                                  target_lang: null,
                                })
                              }}
                              allowClear
                            >
                              {availableLanguages.map(lang => (
                                <option key={lang.label} value={lang.value}>
                                  {lang.label}
                                </option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col xs={24} lg={3}>
                                      <Form.Item name={'target_lang'}>
                                        <Select placeholder="Target Language" allowClear>
                                          {availableLanguages.map(lang => {
                                            if (baseLanguage !== lang.value) {
                                              return (
                                                <option key={lang.label} value={lang.value}>
                                                  {lang.label}
                                                </option>
                                              )
                                            }
                                          })}
                                        </Select>
                                      </Form.Item>
                                    </Col>

            <Form.Item name={'paper_template_id'} initialValue={record?.id}>
              <Input type="hidden" />
            </Form.Item>
          </Row>
          {/* <MinusCircleOutlined onClick={() => removeSection(item?.id)} /> */}
        </Space>
        {/* <Form.Item>
            <Button type="dashed" onClick={() => addNewSubSection(currentSectionId)} block icon={<PlusOutlined />}>
              Save
            </Button>
          </Form.Item> */}
      </Form>
    </Modal>
  )
}
